import { useCallback } from 'react';

import {
  ChangeLifestylesFiltersFunc,
  FetchLifestylesFilterFields,
  OnLifestyleSimilarSearchAction
} from '../../../../../lifestyles/lifestylesTypes';

interface ThreeDStockLifestylesSearchOptions {
  changeLifestylesFilters?: ChangeLifestylesFiltersFunc;
}

function useThreeDStockLifestylesSearch({
  changeLifestylesFilters
}: ThreeDStockLifestylesSearchOptions) {
  const handleSearch = useCallback<(value: string) => void>(
    (value) => {
      const removeFilters = value
        ? []
        : [FetchLifestylesFilterFields.NAME_TAGS];

      changeLifestylesFilters({ nameTags: value }, removeFilters);
    },
    [changeLifestylesFilters]
  );

  const onSearchSimilarImage = useCallback<
    (imageId?: string, imageUrl?: string) => void
  >(
    (imageId, imageUrl) => {
      if (!imageId || !imageUrl) {
        return;
      }

      changeLifestylesFilters(
        {
          searchGlobalByLifestyle: {
            imageUrl
          }
        },
        [
          FetchLifestylesFilterFields.LIFESTYLE_CATEGORY_ID,
          FetchLifestylesFilterFields.LIFESTYLE_PARENT_CATEGORY_IDS
        ]
      );
    },
    [changeLifestylesFilters]
  );

  const onSearchSimilarLifestyle = useCallback<OnLifestyleSimilarSearchAction>(
    (lifestyle) => {
      changeLifestylesFilters({
        searchGlobalByLifestyle: {
          imageUrl: lifestyle.image?.file
        }
      });
    },
    [changeLifestylesFilters]
  );

  const onClearSearchSimilarImage = useCallback<() => void>(() => {
    changeLifestylesFilters({}, [
      FetchLifestylesFilterFields.SEARCH_GLOBAL_BY_LIFESTYLE
    ]);
  }, [changeLifestylesFilters]);

  return {
    handleSearch,
    onSearchSimilarImage,
    onClearSearchSimilarImage,
    onSearchSimilarLifestyle
  };
}

export default useThreeDStockLifestylesSearch;
